import fillForm from './fillForm';
import getFormValues from './getFormValues';
import hasFormChanged from './hasFormChanged';

// ----------------------------------------------------------------------------

function setupFormChange(
    elForm: HTMLFormElement,
    data: Record<string, unknown>,
    fnChange: (changed: boolean) => void,
): () => void {
    fillForm(elForm, data);

    const originalData = getFormValues(elForm);
    let lastChanged = false;

    function handleChange(): void {
        const changed = hasFormChanged(elForm, originalData);

        if (changed === lastChanged) {
            return;
        }

        lastChanged = changed;
        fnChange(changed);
    }

    fnChange(lastChanged);

    elForm.addEventListener('input', handleChange);
    elForm.addEventListener('change', handleChange);

    return (): void => {
        elForm.removeEventListener('input', handleChange);
        elForm.removeEventListener('change', handleChange);
    };
}

// ----------------------------------------------------------------------------

export default setupFormChange;
